import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ComposerReleaseFieldProps {
  items?: CatalogItem[];
  value?: string;
  onChange: (uuid: string | undefined) => void;
}

/**
 * Which release the post is about.
 *
 * The caption writer needs a title and an artist, and the post carries the
 * release's smartlink, so this is not decoration — without it the AI buttons
 * have nothing to write about.
 */
const ComposerReleaseFieldComponent: React.FC<ComposerReleaseFieldProps> = ({ items, value, onChange }) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      (items ?? []).map((item) => (
        <option key={item.uuid} value={item.uuid}>
          {`${item.title} — ${item.artistName}`}
        </option>
      )),
    [items]
  );

  const change = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) =>
      onChange(event.target.value === '' ? undefined : event.target.value),
    [onChange]
  );

  const label = intl.formatMessage({ id: 'app.sml.promote.composer.release', defaultMessage: 'Release' });

  return (
    <div className={styles.releaseRow}>
      <span className={styles.releaseLabel}>{label}</span>
      <select className={styles.selectSmall} value={value ?? ''} aria-label={label} onChange={change}>
        <option value="">
          {intl.formatMessage({ id: 'app.sml.promote.composer.release.none', defaultMessage: 'Not about a release' })}
        </option>
        {options}
      </select>
    </div>
  );
};

export const ComposerReleaseField = TypedMemo(ComposerReleaseFieldComponent);
